<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column is-11">
          <h1 class="title green">{{ title }}</h1>
        </div>
        <div class="column has-text-right">
          <button
            v-if="id !== 0 && id !== -1 && id != null"
            type="button"
            class="button is-danger"
            @click="deleteOccurence(id)"
          >
            <b-icon icon="delete-outline" />
          </button>

          <button type="button" class="button is-primary" @click="validateBeforeSubmit">
            <b-icon icon="content-save-outline" />
          </button>
        </div>
      </div>
      <hr />

      <b-field v-if="id !== -1 && !this.$route.params.idtocopy" horizontal :label="$translate('id_sole') | capitalize">
        <b-input v-if="id !== -1" v-model="id" name="id_sole" disabled="true" />
      </b-field>
      <b-field
        horizontal
        :label="$translate('CUI') | capitalize"
        :message="errors.first('CUI')"
        :type="{ 'is-danger': errors.has('CUI') }"
      >
        <b-input v-model="sole.CUI" v-validate="'required|unique'" data-vv-validate-on="blur" name="CUI" />
      </b-field>
      <b-field
        horizontal
        :label="$translate('name') | capitalize"
        :message="errors.first('name')"
        :type="{ 'is-danger': errors.has('name') }"
      >
        <b-input v-model="sole.commercial_name" v-validate="'required'" name="name" />
      </b-field>
      <b-field
        horizontal
        :label="$translate('available_shapes') | capitalize"
        :message="errors.first('available_shapes')"
        :type="{ 'is-danger': errors.has('available_shapes') }"
      >
        <b-select
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="available_shapes"
          v-model="sole.shapes"
          multiple
        >
          <option v-for="shape in shapes" :key="shape.id" :value="shape">
            {{ shape.commercial_name + ' ' + shape.fit_code }}
          </option>
        </b-select>
      </b-field>
      <b-field
        horizontal
        :label="$translate('tacc') | capitalize"
        :type="{ 'is-danger': errors.has('foggia') }"
        :message="errors.first('foggia')"
      >
        <b-select
          :placeholder="$translate('select_foggia') | capitalize"
          v-model="sole.foggia"
          v-validate="'required'"
          name="foggia"
        >
          <option v-for="foggia in fogge" :key="foggia.id" :value="foggia">{{ foggia.commercial_name }} </option>
        </b-select>
      </b-field>

      <b-field horizontal :label="$translate('Pun_F') | capitalize">
        <b-select :placeholder="$translate('select_tread') | capitalize" v-model="sole.tread" name="tread">
          <option :value="null"></option>
          <option v-for="tread in treads" :key="tread.id" :value="tread">{{ tread.commercial_name }} </option>
        </b-select>
      </b-field>
      <b-field
        horizontal
        :label="$translate('color') | capitalize"
        :type="{ 'is-danger': errors.has('sole_color') }"
        :message="errors.first('sole_color')"
      >
        <b-autocomplete
          v-model="selectedColor"
          :v-validate="'required|list_colors'"
          :data="filteredColors"
          :placeholder="$translate('e.g. Milady-Blu 67...') | capitalize"
          icon="magnify"
          field="commercial_name"
          clearable
          name="sole_color"
        >
          <template #empty
            >No results found</template
          >
        </b-autocomplete>
      </b-field>

      <b-field v-if="imageAlreadyUploaded" horizontal>
        <table>
          <tr>
            <img :src="sole.image" width="100px" height="auto" :alt="sole.image.name" />
          </tr>
          <tr>
            <b-button type="is-danger" icon-left="delete-outline" @click="removeImage()">
              {{ $translate('remove_image') | capitalize }}
            </b-button>
          </tr>
        </table>
      </b-field>

      <b-field
        v-else
        class="file"
        :label="$translate('image') | capitalize"
        :message="errors.first('image')"
        :type="{ 'is-danger': errors.has('image') }"
        horizontal
      >
        <b-upload v-model="file" v-validate="'required'" name="image">
          <a class="button is-primary">
            <b-icon icon="upload" />
            <span>{{ $translate('upload_button') }}</span>
          </a>
          <span v-if="file" class="file-name">
            {{ file.name }}
          </span>
        </b-upload>
      </b-field>
      <hr class="green" />
      <b-field :label="$translate('addingchar') | capitalize" horizontal>
        <b-input v-model="sole.addingChar" type="textarea"></b-input>
      </b-field>
      <b-field v-if="$moduleConfiguration[module].soleHasRialzi" horizontal :label="$translate('rialzi') | capitalize">
        <b-switch v-model="sole.hasRialzi" />
      </b-field>
      <b-field
        v-if="$moduleConfiguration[module].soleHasCampanatura"
        horizontal
        :label="$translate('camber') | capitalize"
      >
        <b-switch v-model="sole.hasCampanatura" />
      </b-field>
      <b-field
        v-if="$moduleConfiguration[module].soleHasSperonatura"
        horizontal
        :label="$translate('speronatura') | capitalize"
      >
        <b-switch v-model="sole.hasSperonatura" />
      </b-field>
      <b-field
        v-if="$moduleConfiguration[module].soleHasCorrections"
        horizontal
        :label="$translate('corrections') | capitalize"
      >
        <b-switch v-model="sole.hasCorrections" />
      </b-field>
      <b-field
        v-if="$moduleConfiguration[module].soleHasCustomSizes"
        class="is-narrow"
        horizontal
        :label="$translate('custom_sizes') | capitalize"
      >
        <b-switch v-model="customSizeRange" />
        <b-numberinput
          class="test"
          :placeholder="$translate('custom_input_min')"
          v-if="customSizeRange"
          v-model="sole.sizes.min"
          :v-validate="'required'"
          :controls="false"
        ></b-numberinput>
        <b-numberinput
          :placeholder="$translate('custom_input_max')"
          class="test"
          v-if="customSizeRange"
          v-model="sole.sizes.max"
          :v-validate="'required'"
          :controls="false"
        ></b-numberinput>
      </b-field>
    </div>
    <b-loading :is-full-page="true" :active.sync="isSaveDisabled" :can-cancel="false" />
  </section>
</template>

<script>
import permissionMixin from '@/helpers/mixins/permissionMixin'
//import { storage } from 'firebase';

export default {
  name: 'SoleForm',
  $_veeValidate: {
    validator: 'new',
  },
  mixins: [permissionMixin],
  props: ['module'],
  data() {
    return {
      id: 0,
      title: '',
      uploadValue: 0,
      isSaveDisabled: false,
      imageAlreadyUploaded: false,
      toRemoveoldImage: false,
      file: null,
      customSizeRange: false,
      sole: {
        CUI: '',
        commercial_name: '',
        sizes: {},
        shapes: [],
        image: null,
        color: null,
        foggia: {},
        tread: {},
        addingChar: '',
        hasCorrections: false,
        hasRialzi: false,
        hasCampanatura: false,
        hasSperonatura: false,
      },
      shapes: [],
      fogge: [],
      treads: [],
      colors: [],
      selectedColor: null,
    }
  },
  computed: {
    filteredColors() {
      if (this.selectedColor) {
        return this.colors.filter(color => {
          return (
            color.commercial_name
              .toString()
              .toLowerCase()
              .indexOf(this.selectedColor.toLowerCase()) >= 0
          )
        })
      } else {
        return this.colors
      }
    },
    areShapeSameKind() {
      const referenceShape = this.sole.shapes[0].commercial_name.split(' ')[0]
      return this.sole.shapes.every(shape => shape.commercial_name.split(' ')[0] === referenceShape)
    },
  },
  async mounted() {
    let isAllowed = false
    switch (this.userInfo.type) {
      case 'A':
        isAllowed = true
        break
      case 'I':
        if (this.userInfo.level === 'S' || this.userInfo.level === '2') isAllowed = true
        break
    }
    if (!isAllowed) this.$router.push('/forbidden')
    if (this.$route.params.id === undefined && !this.$route.params.idtocopy) {
      await this.$router.push('/forbidden')
    }

    this.title = this.id === -1 ? this.$translate('new_sole') : this.$translate('modify_sole')

    await this.$db
      .collection(this.$moduleConfiguration[this.module].shapes)
      .get()
      .then(shapes => {
        const availableShapes = []
        shapes.forEach(doc => {
          let shape = doc.data()
          shape.id = doc.id
          availableShapes.push(shape)
        })
        this.shapes = availableShapes.sort((first, second) =>
          first.commercial_name.localeCompare(second.commercial_name)
        )
      })

    await this.$db
      .collection(this.$moduleConfiguration[this.module].materials.Fog)
      .get()
      .then(fogge => {
        const availableFogge = []
        fogge.forEach(doc => {
          let foggia = doc.data()
          foggia.id = doc.id
          availableFogge.push(foggia)
        })
        this.fogge = availableFogge
      })

    await this.$db
      .collection(this.$moduleConfiguration[this.module].materials.Col)
      .get()
      .then(colors => {
        const availableColors = []
        colors.forEach(doc => {
          let color = doc.data()
          color.id = doc.id
          availableColors.push(color)
        })
        this.colors = availableColors
      })

    await this.$db
      .collection(this.$moduleConfiguration[this.module].materials.Pun)
      .get()
      .then(treads => {
        const availableTreads = []
        treads.forEach(doc => {
          let tread = doc.data()
          tread.id = doc.id
          availableTreads.push(tread)
        })
        this.treads = availableTreads
      })

    this.$validator.extend('unique', async value => {
      let counter = 0
      await this.$db
        .collection(this.$moduleConfiguration[this.module].soles)
        .where('CUI', '==', value)
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            if (doc.id !== this.id) {
              counter++
            }
          })
        })
      return counter <= 0
    })

    this.$validator.extend('list_colors', {
      getMessage: this.$translate('list_colors_error'),
      validate: value => {
        return !!this.colors.find(color => color.commercial_name === value)
      },
    })

    if (this.id !== -1 && this.$route.params.idtocopy === undefined) {
      await this.loadDataToEdit()
    } else {
      if (this.$route.params.idtocopy !== undefined) {
        await this.loadDataToCopy()
      }
    }
  },

  created() {
    this.sole.shapes = []
    this.id = this.$route.params.id
  },
  methods: {
    removeImage() {
      this.imageAlreadyUploaded = false
      this.toRemoveoldImage = true
      this.file = null
      this.sole.image = ''
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result && this.areShapeSameKind) {
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('success_form'),
            type: 'is-success',
          })
          this.send()
          return
        }
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate(this.areShapeSameKind ? 'failed_form' : 'unmatched_shapes'),
          type: 'is-danger',
        })
      })
    },

    deleteOccurence(idtoerase) {
      this.$buefy.dialog.confirm({
        title: this.$translate('attention'),
        message: this.$translate('sole_message_destroy'),
        cancelText: this.$translate('undo'),
        confirmText: this.$translate('sole_message_confirm'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () =>
          this.$db
            .collection(this.$moduleConfiguration[this.module].soles)
            .doc(idtoerase)
            .delete()
            .then(async () => {
              this.$buefy.notification.open({
                duration: 3000,
                message: this.$translate('success_delete'),
              })
              await this.$router.push({
                name: 'soles',
                params: { module: this.module },
              })
            }),
      })
    },

    loadDataToEdit() {
      this.$db
        .collection(this.$moduleConfiguration[this.module].soles)
        .doc(this.id)
        .get()
        .then(doc => {
          this.sole = doc.data()
          this.imageAlreadyUploaded = !!this.sole.image
          this.customSizeRange = !!Object.keys(this.sole.sizes).length > 0
          this.selectedColor = this.sole.color.commercial_name
          if (this.sole.foggia && this.sole.foggia.id) {
            this.sole.foggia = this.fogge.find(f => f.id === this.sole.foggia.id) || this.sole.foggia
          }
          if (this.sole.tread && this.sole.tread.id) {
            this.sole.tread = this.treads.find(t => t.id === this.sole.tread.id) || this.sole.tread
          }
          if (this.sole.shapes && this.sole.shapes.length) {
            this.sole.shapes = this.sole.shapes.map(s => this.shapes.find(sh => sh.id === s.id) || s)
          }
          this.toUpdateModels = true
        })
    },

    async send() {
      if (this.id === -1 || this.$route.params.idtocopy) {
        this.sole.registeredAt = new Date().getTime()
        let soleRef = await this.$db.collection(this.$moduleConfiguration[this.module].soles).add(this.sole)
        this.id = soleRef.id
      }
      this.isSaveDisabled = true
      if (!this.imageAlreadyUploaded) {
        let storageRef = this.$storage.ref(`${this.$moduleConfiguration[this.module].soles}/${this.id}`)
        if (this.toRemoveoldImage) {
          await storageRef.delete()
        }
        if (this.file) {
          let snapshot = await storageRef.put(this.file)
          this.sole.image = await snapshot.ref.getDownloadURL()
          delete this.sole.file
          this.imageAlreadyUploaded = true
        } else {
          this.sole.image = ''
          this.imageAlreadyUploaded = false
        }
      }
      this.toRemoveoldImage = false
      this.isSaveDisabled = false

      if (!this.customSizeRange) {
        this.sole.sizes = {}
      }
      if (!this.sole.tread) {
        this.sole.tread = {}
      }

      this.sole.color = this.colors.find(color => color.commercial_name === this.selectedColor)
      this.sole.module = this.module
      await this.$db
        .collection(this.$moduleConfiguration[this.module].soles)
        .doc(this.id)
        .update(this.sole)
        .catch(() => {
          //err => {
          //console.log(err);
          this.isLoading = false

          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('error_form_server'),
            type: 'is-danger',
          })
        })
      this.isSaveDisabled = false
      await this.$router.push({
        name: 'soles',
        params: { module: this.module },
      })
    },
    loadDataToCopy() {
      this.$db
        .collection(this.$moduleConfiguration[this.module].soles)
        .doc(this.$route.params.idtocopy)
        .get()
        .then(doc => {
          this.sole = doc.data()
          this.customSizeRange = !!this.sole.sizes
          this.imageAlreadyUploaded = false
          this.customSizeRange = !!Object.keys(this.sole.sizes).length > 0
          this.selectedColor = this.sole.color.commercial_name
          if (this.sole.foggia && this.sole.foggia.id) {
            this.sole.foggia = this.fogge.find(f => f.id === this.sole.foggia.id) || this.sole.foggia
          }
          if (this.sole.tread && this.sole.tread.id) {
            this.sole.tread = this.treads.find(t => t.id === this.sole.tread.id) || this.sole.tread
          }
          if (this.sole.shapes && this.sole.shapes.length) {
            this.sole.shapes = this.sole.shapes.map(s => this.shapes.find(sh => sh.id === s.id) || s)
          }
        })
    },
  },
}
</script>
<style scoped>
.container >>> .is-narrow .field {
  flex-grow: 0 !important;
}
</style>
